import styled from "styled-components"

export const AccordionContent = styled.div(({theme}) => ({
    marginTop: "32px",
    [theme.breakpoint.lg()]: {
        display: "flex",
        gap: "64px",
        marginTop: "40px"
    }
}))

export const AccordionItem = styled.div(({theme}) => ({
    width: "100%",
    [theme.breakpoint.lg()]: {
        width: "50%",
    }
}))

export const Divider = styled.div(({ theme }) => ({
    width: '100%',
    height: 1,
    background: "#D1DBE3",
    marginBottom: "32px",

    [theme.breakpoint.lg()]: {
        width: 1,
        height: 'auto',
    }
}))